import { Subscription } from 'rxjs';
import { MessagingService } from './_services/messaging.service';
import { AccountService } from './_services/account.service';
import { User } from './_models/user';
import { Component } from '@angular/core';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  user: User;
  title: string = 'OHI System Administrator';
  subtitle: string = '';
  subscription: Subscription;

  constructor(
    private accountService: AccountService,
    private messagingService: MessagingService
  ) {

    this.user = this.accountService.userValue;

    this.accountService.user.subscribe(x => {
        this.user = x;
        console.log('User changed: ',  this.user);
      });
      
    this.subscription = this.messagingService.onMessage().subscribe(data => {
      switch (data.messageType) {
        case 1:
          switch (data.message) {
            case 'webinars': this.subtitle = 'Edit Webinars';
              break;
            case 'resources': this.subtitle = 'Edit Digital Resources';
              break;
          }
          break;
      }
    });

  }
  canManageUsers() {
    return this.user && this.user.hasOneOfRoles([1,2,3]);
  }

  logout() {
    this.accountService.logout();
  }
}
